export function modalSlide(setElement) {
  // const IS_ACTIVE = 'is-active';
  // setElement.classList.add(IS_ACTIVE);
}
